import script from "./AppTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTable.vue?vue&type=script&setup=true&lang=ts"

import "./AppTable.vue?vue&type=style&index=0&id=929c2372&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-929c2372"]])

export default __exports__